// updateCustomFieldValue for the Opportunities list. Deliberately NO optimistic response and NO store
// configs: the list's value nodes share the id this mutation returns, so an optimistic patch would change
// the cell before the server confirmed. The cell changes only once the save succeeds. The list refetches
// through retry() on success, which also moves the row if the user is sorted on this column. The shared
// update_custom_field_value_mutation keeps its optimistic behaviour for the record page, task modal and
// timesheets.
import {graphql} from 'react-relay';
import type {Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateCustomFieldListValueMutation($input: UpdateCustomFieldValueInput!) {
		updateCustomFieldValue(input: $input) {
			customFieldValue {
				node {
					id
					key
					value
				}
			}
		}
	}
`;

export interface UpdateCustomFieldListValueInput {
	entityId: string;
	entityType: 'PROJECT';
	key: string;
	value: string | null;
}

function commit(
	environment: Environment,
	input: UpdateCustomFieldListValueInput,
	onSuccess: () => void,
	onError: (e: unknown) => void
) {
	tracking.trackEvent('CustomFieldValue - Updated');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
